export interface ISnAudio {
  channels: {
    [name: string]: {
      label: string;
      value: number;
      isDefault?: boolean;
    };
  };
  optimalBitrate: {
    [name: string]: {
      label: string;
      value: number;
    };
  };
  sampleRate: {
    [name: string]: {
      label: string;
      value: number;
    };
  };
}
